
const onPointClick = (evt) => {
  const id = evt.target.closest('.point').dataset.id;
  const btn = document.querySelector('[data-open-modal="' + id + '"]');
  btn.click();
};

const initSchemePoints = () => {
  const points = document.querySelectorAll('.point');

  points.forEach((item) => {
    item.addEventListener('click', onPointClick);
  });
};

export {initSchemePoints};
